import React from "react"
import styled from "styled-components"
import LogoBar from "./LogoBar"
import LanguageBar from "../components/LanguageBar"
import AccountBar from "../components/AccountBar"

const TopBar = ({
  className,
  hasLogoBar = true,
  hasLanguageBar = true,
  hasAccountBar = true,
}) => {
  return (
    <div className={className}>
      {hasLogoBar && <LogoBar />}
      {hasLanguageBar && <LanguageBar />}
      {hasAccountBar && <AccountBar />}
    </div>
  )
}

const StyledTopBar = styled(TopBar)`
  position: fixed;
  top: ${props => props.theme.topBar.offset};
  left: ${props => props.theme.topBar.offset};
  right: ${props => props.theme.topBar.offset};
  height: ${props => props.theme.topBar.height};
  z-index: ${props => props.theme.zIndexLayer.header};
`

export default StyledTopBar
